import React, { useMemo } from 'react'

import { BASE_URL } from '../../constants'

import { useItems } from '../hooks'

import styles from '../../common/components/Input.module.css'

export const ICON_TYPES = {
  AI: 'ai',
  INCIDENTS: 'incidents',
}

const IconSelect = ({
  label,
  className,
  value,
  onChange,
  disabled,
  iconDir,
  type,
}) => {
  const [{ response: icons, isLoading, error }] = useItems(`icons/${type}`)

  const options = useMemo(() => {
    if (!icons) return []
    return icons.map((icon) => ({ label: icon, value: icon }))
  }, [icons])

  if (isLoading)
    return (
      <div
        className={`${styles.container} ${
          className || styles.defaultContainer
        }`}
      >
        {label && <label>{label}</label>}
        Loading...
      </div>
    )

  if (error)
    return (
      <div>
        {label} - {error}
      </div>
    )

  return (
    <div
      className={`${styles.container} ${className || styles.defaultContainer}`}
    >
      {label && <label>{label}</label>}
      <img src={`${BASE_URL}${iconDir}${value}`} alt={label} />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={styles.input}
      >
        {options.map((option, i) => (
          <option value={option.value} key={i}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default IconSelect
